import {
  LayoutDashboard,
  ChartSpline,
  Zap,
  Power,
  PowerOff,
  UserX,
  Key,
  FileText,
  AlertTriangle,
  Unplug,
  Receipt,
  TrendingUp,
  Droplets,
  FileX,
  Settings2,
  MapPin,
  Building2,
  Gauge,
  Bell,
  Home,
  FolderKanban,
  ClipboardList,
  Sparkles,
  Users,
} from "lucide-react"
import { NavItem } from "@/types/nav"

export const utilityAdminNav: NavItem[] = [
  {
    title: "Dashboard",
    url: "/dashboard/utility-admin/dashboard/overview",
    icon: LayoutDashboard,
  },
  {
    title: "Manage",
    url: "/dashboard/utility-admin/manage",
    icon: FolderKanban,
    items: [
      {
        title: "Properties",
        url: "/dashboard/utility-admin/manage/properties",
      },
      {
        title: "Utilities",
        url: "/dashboard/utility-admin/manage/utilities",
      },
      {
        title: "Residents",
        url: "/dashboard/utility-admin/manage/residents",
      },
      {
        title: "Lockbox",
        url: "/dashboard/utility-admin/manage/lockbox",
      },
      {
        title: "Trash bins",
        url: "/dashboard/utility-admin/manage/trash-bins",
      },
      {
        title: "Documents",
        url: "/dashboard/utility-admin/manage/documents",
      },
      {
        title: "Provider Lookup",
        url: "/dashboard/utility-admin/manage/provider-lookup",
      }
    ],
  },
  {
    title: "Work Order",
    url: "/dashboard/utility-admin/work-orders",
    icon: ClipboardList,
    items: [
      {
        title: "All",
        url: "/dashboard/work-orders",
        badgeKey: "needs-action-count",
      },
      {
        title: "Add New Property",
        url: "/dashboard/utility-admin/work-orders/acquisitions",
      },
      {
        title: "Add New Utility",
        url: "/dashboard/utility-admin/work-orders/activate-service",
      },
      {
        title: "Deactivate Utility",
        url: "/dashboard/utility-admin/work-orders/deactivate-service",
      },
      {
        title: "Trash requests",
        url: "/dashboard/utility-admin/work-orders/trash-requests",
      },
      {
        title: "Disconnects",
        url: "/dashboard/utility-admin/work-orders/disconnects",
      },
      {
        title: "One Time Bill Pay",
        url: "/dashboard/utility-admin/work-orders/one-time-bill-pay",
      },
      {
        title: "Resident Requests",
        url: "/dashboard/utility-admin/work-orders/resident-requests",
      },
      {
        title: "Miscellaneous",
        url: "/dashboard/utility-admin/work-orders/other",
      },
      {
        // Mentions inbox — @-mentions + replies to your own comments.
        // Backed by /api/v1/mentions/* and the unread badge is driven
        // by /api/v1/mentions/summary/.
        title: "Mentions",
        url: "/dashboard/utility-admin/work-orders/mentions",
        badgeKey: "mentions-unread-count",
      }
    ],
  },
  {
    title: "Reports",
    url: "/dashboard/utility-admin/reports",
    icon: ChartSpline,
    items: [
      {
        title: "Property Utility Audit",
        url: "/dashboard/utility-admin/reports/property-utility-audit",
      },
      // {
      //   title: "Active Bills",
      //   url: "/dashboard/utility-admin/reports/active-bills",
      // },
      {
        title: "Spikes",
        url: "/dashboard/utility-admin/reports/spikes",
      },
      {
        title: "All Fees",
        url: "/dashboard/utility-admin/reports/all-fees",
      },
      {
        title: "Markets",
        url: "/dashboard/utility-admin/reports/markets",
      },
      {
        title: "SLA Breach Report",
        url: "/dashboard/utility-admin/reports/sla-breach-report",
      }
    ],
  },
  {
    title: "AI Tools",
    url: "/dashboard/ai-tools",
    icon: Sparkles,
    items: [
      {
        title: "Fee Analyzer",
        url: "/dashboard/ai-tools/fee-analyzer",
      }
    ],
  },
  {
    title: "Settings",
    url: "/dashboard/utility-admin/settings",
    icon: Settings2,
    items: [
      {
        title: "Spike Thresholds",
        url: "/dashboard/utility-admin/settings/thresholds",
      },
      {
        title: "Notifications",
        url: "/dashboard/settings/notifications",
      }
    ],
  }
] 
